<div class="nav-bar" *ngIf="sideNavBar">
    <div class="item d-none d-lg-flex">
      <img [src]="sideNavBar.logo" class="logo" alt="logo">
    </div>
    <ng-container *ngFor="let item of sideNavBar.items">
      <div *ngIf="item.visible" class="item" [routerLink]="[item.route]" routerLinkActive="active">
        <i class="material-icons notranslate">{{item.icon}}</i>
        <span>{{item.label}}</span>
      </div>
    </ng-container>
</div>
